import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import Translate from '../../core/translate';
import API from '../../services/api';
import Common from '../../services/common';
import Security from '../../services/seguridad';
import Alert from '../alerts';
import { Button, Dialog, OverlayPanel, Password, Tooltip } from '../prime';
import styles from './index.module.scss';

interface IProps { 
  storage?: IDataStorage;
  syncShow?: (show: (event: React.SyntheticEvent<Element, Event>, target: EventTarget) => void) => void;
}

interface IState  {
  storage?: IDataStorage;

  password?: {
    old?: string;
    new1?: string;
    new2?: string;
  }
}

class Index extends React.Component<IProps, IState> {
  private Panel : OverlayPanel | null = null;

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    this.props.syncShow && this.props.syncShow(this.show);
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    return res;
  }
  
  /** muestra el diálogo */
  show = (event: React.SyntheticEvent<Element, Event>, target: EventTarget) => {
    this.Panel?.show(event, target);
  }

  render() {
    const { password } = this.state;
    const user = Security.User;
    const t = Translate.get("component/userinfopanel", this.state.storage?.languaje);
    
    return <>
      <OverlayPanel 
        ref={(el:OverlayPanel) => this.Panel = el} 
        dismissable 
        className={`${styles.panel} p-shadow-5`}
        appendTo={(window as any).mainbody}
      >
        <div className={`p-grid nested-grid ${styles.panelGrid}`}>
          <div className="p-col-4" >
            <img alt="Avatar" className={styles.avatar} src={ user?.avatar?.url ?? user?.avatar?.content ??"/images/avatar.png"} /> 
          </div>
          <div className="p-col-8">
            <Tooltip target=".sir-name" position="bottom" className="sir-tooltip" />
            <div className={`sir-name p-text-nowrap p-text-truncate ${styles.username}`} data-pr-tooltip={user?.nombre ?? user?.login}>{user?.nombre ?? user?.login}</div>
            <div className={`sir-name p-text-nowrap p-text-truncate ${styles.email}`} data-pr-tooltip={user?.email ?? t("SinCorreo")}>{user?.email ?? t("SinCorreo")}</div>
            <Button 
              label={t("MiCuenta")}
              icon="fas fa-briefcase" 
              className={styles.micuenta}
              disabled
              tooltip={t("MiCuenta.Tooltip")}
              tooltipOptions={{position:'bottom'}}
              onClick={() => Common.url.redirect("/cliente")}
            />
            <Button 
              label={t("Reset")}
              icon="fas fa-sync" 
              className={`${styles.micuenta} p-button-secondary`}
              style={{ marginTop: 5 }}
              tooltip={t("Reset.Tooltip")}
              tooltipOptions={{position:'bottom'}}
              onClick={() => {
                Common.session.resetAll();
                (window.location as any).reload(true);
              }}
            />
          </div>
          <div className={`p-col-12 ${styles.panelFooter}`}>
            <div className="p-grid">
              <div className="p-col-6">
                <Button 
                  label={t("ChangePassword")}
                  className={`p-button-raised p-button-text ${styles.logout}`} 
                  style={{ float: 'left' }}
                  tooltip={t("ChangePassword.Tooltip")}
                  tooltipOptions={{position:'bottom'}}
                  onClick={() => this.setState({ password: { } })}
                />
              </div>
              <div className="p-col-6">
                <Button 
                  label={t("CerrarSesion")}
                  icon="pi pi-power-off" 
                  className={`p-button-raised p-button-danger p-button-text ${styles.logout}`} 
                  tooltip={t("CerrarSesion.Tooltip")}
                  tooltipOptions={{position:'bottom'}}
                  onClick={() => Common.url.redirect('/logout')}
                />
              </div>
            </div>
          </div>
        </div>
      </OverlayPanel>
      <Dialog 
        header={t("ChangePassword")}
        visible={!!password} 
        onHide={() => this.setState({ password: undefined })} 
        dismissableMask 
        footer={<>
          <Button 
            label={t("ChangePassword")}
            tooltip={t("ChangePassword.Tooltip")}
            icon="pi pi-save" 
            tooltipOptions={{position:'top'}}
            onClick={() => {
              if (!password?.new1) return Alert.error(t("ChangePassword.Error.Empty.Title"), t("ChangePassword.Error.Empty.Msg"));
              if (password?.new1 !== password?.new2) return Alert.error(t("ChangePassword.Error.Dif.Title"), t("ChangePassword.Error.Dif.Msg"));
              API.seguridad().usuario().setPassword({ usuario: user?.id, password: password?.new1, hidentoken: 'Nw2p8BEPaVnCdpkEFLMg#p_FXjq_vFb+H9pnN6tbh+J+Kb+XHb?fBMd' })
                .then(res => {
                  Alert.reponse(res);
                  if (res?.data) {
                    Alert.info(t('ChangePassword.Success.Title'),t('ChangePassword.Success.Mensaje'));
                    this.setState({ password: undefined });
                  }
                })
                .catch((ex:any) => Alert.error(t('ChangePassword.Error.Title'), `${ex}`))
            }}
          />
        </>}
      >
        <div className="form-group">
          <label className={styles.inputTitle}>{t("Password.New1")}</label>
          <div className={`${styles.addons} p-inputgroup`}>
            <Password autoFocus name='password' className={styles["input-password"]} value={password?.new1} onChange={(e : any) => { if (password) password.new1 = e.target.value; this.setState({ password })}} />
          </div>
        </div>
        <div className="form-group">
          <label className={styles.inputTitle}>{t("Password.New2")}</label>
          <div className={`${styles.addons} p-inputgroup`}>
            <Password name='password' className={styles["input-password"]} value={password?.new2} feedback={false} onChange={(e : any) => { if (password) password.new2 = e.target.value; this.setState({ password })}} />
          </div>
        </div>
      </Dialog>
    </>;
  }
}

export { Index };
export default connect((s:any) => ({ storage:s.main }))(Index);